module.exports = require('./$.global');


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/$.path.js
// module id = 299
// module chunks = 0